import React from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  heading: string;
  description?: string;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  heading,
  description,
  className,
}) => {
  return (
    <header className={cn('py-2 md:py-4 animate-fade-in', className)}>
      <div className="text-center">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-1 inline-block">
          {heading}
        </h1>
        <div className="h-0.5 w-20 mx-auto bg-gradient-to-r from-primary/50 via-primary to-primary/50 mb-1"></div>
      </div>
      {description && (
        <p className="text-muted-foreground text-center text-sm">
          {description}
        </p>
      )}
    </header>
  );
};

export default PageHeader;
